// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d6fb4e3","952":"82c0f852"}[chunkId] + ".chunk.js";
};